import {FunctionComponent} from 'react';

import {enUS, ru, arDZ, uk, fr} from 'date-fns/locale';

// import {ReactComponent as RusIcon} from 'assets/svg/rus-flag.svg';
// import {ReactComponent as UkraineIcon} from 'assets/svg/ukraine-flag.svg';
import {ReactComponent as FrIcon} from 'assets/svg/fr-flag.svg';
import {ReactComponent as UsaIcon} from 'assets/svg/usa-flag.svg';

import {IS_CAR} from 'core/constants/env';

export enum Locales {
    en = 'en',
    ru = 'ru-RU',
    ar = 'ar',
    ua = 'ua',
    fr = 'fr',
}

export const LocaleNames: Record<string, {name: string; icon: FunctionComponent}> = {
    en: {name: 'English', icon: UsaIcon},
    ...(IS_CAR && {fr: {name: 'French', icon: FrIcon}}),
    // ua: {name: 'UKR', icon: UkraineIcon},
    // 'ru-RU': {name: 'RUS', icon: RusIcon},
};

export const locales: {[id: string]: Locale} = {
    [Locales.en]: enUS,
    [Locales.ru]: ru,
    [Locales.ua]: uk,
    [Locales.ar]: arDZ,
    [Locales.fr]: fr,
};
